import { useEffect, useRef } from 'react';

/**
 * Rainbow swatch that opens the native color picker.
 * Uncontrolled input (synced from props) avoids mobile Chrome flicker when
 * React re-renders on every color change while the picker is open.
 */
export function CustomColorSwatch({
  color,
  onColor,
  className = 'ox-swatch-btn ox-swatch-rainbow',
}: {
  color: string;
  onColor: (hex: string) => void;
  className?: string;
}) {
  const ref = useRef<HTMLInputElement>(null);
  const hex = color.startsWith('#') ? color : '#000000';

  useEffect(() => {
    if (ref.current && ref.current.value.toLowerCase() !== hex.toLowerCase()) {
      ref.current.value = hex;
    }
  }, [hex]);

  return (
    <label className={className} title="Personalizado">
      <input
        ref={ref}
        type="color"
        defaultValue={hex}
        onClick={(e) => e.stopPropagation()}
        onChange={(e) => onColor(e.target.value)}
      />
    </label>
  );
}
